module.exports = __webpack_public_path__ + "static/media/weng_icon.688745e4.png";